(() => {
  "use strict";

  const ACTION_SELECTOR = [
    ".peguu-button--primary",
    ".peguu-button--secondary",
    ".peguu-flow-actions__button--next",
    ".peguu-sticker-summary__button",
    ".peguu-contact__whatsapp-button",
  ].join(",");
  const TOUCH_QUERY = "(hover: none) and (pointer: coarse)";
  const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";
  const TOUCH_DELAY_MS = 1000;
  const REDUCED_MOTION_DELAY_MS = 40;
  const recentTouchTargets = new WeakMap();
  const replayingTargets = new WeakSet();
  const runningTargets = new WeakSet();

  const getAction = (target) =>
    target instanceof Element ? target.closest(ACTION_SELECTOR) : null;

  const isUnavailable = (action) =>
    action.matches(":disabled") ||
    action.classList.contains("is-disabled") ||
    action.getAttribute("aria-disabled") === "true";

  const rememberTouch = (event) => {
    const action = getAction(event.target);

    if (!action) return;
    if (event.pointerType && event.pointerType !== "touch" && event.pointerType !== "pen") return;

    recentTouchTargets.set(action, Date.now());
  };

  const cameFromTouch = (action, event) => {
    const lastTouch = recentTouchTargets.get(action) || 0;

    if (Date.now() - lastTouch < 1500) return true;
    return event.detail > 0 && !("pointerType" in event && event.pointerType === "mouse");
  };

  const handleClick = (event) => {
    if (
      event.target instanceof Element &&
      event.target.closest("[data-peguu-validation-alert]")
    ) return;

    const action = getAction(event.target);

    if (!action || !window.matchMedia(TOUCH_QUERY).matches) return;

    if (replayingTargets.has(action)) {
      replayingTargets.delete(action);
      return;
    }

    if (!cameFromTouch(action, event) || isUnavailable(action)) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (runningTargets.has(action)) return;

    runningTargets.add(action);
    action.classList.add("is-touch-animating");

    const delay = window.matchMedia(REDUCED_MOTION_QUERY).matches
      ? REDUCED_MOTION_DELAY_MS
      : TOUCH_DELAY_MS;

    window.setTimeout(() => {
      replayingTargets.add(action);
      action.click();

      window.setTimeout(() => {
        action.classList.remove("is-touch-animating");
        runningTargets.delete(action);
        replayingTargets.delete(action);
      }, 100);
    }, delay);
  };

  document.addEventListener("pointerdown", rememberTouch, true);
  document.addEventListener("touchstart", rememberTouch, { capture: true, passive: true });
  document.addEventListener("click", handleClick, true);
})();
